import { useState } from "react";
import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import CustomizeMeal from "../../components/dashboard/dashboardPartials/CustomizeMeal";
import MealCancelForm from "../../components/dashboard/dashboardPartials/MealCancelForm";
import UpgradeMealSelection from "../../components/dashboard/dashboardPartials/UpgradeMealSelection";

const UpgradeMealSubsctiptionPage = () => {
  const account = {
    stats: {
      mySubscriptions: "1",
      myOrders: "2",
    },
    subscriptions: [
      {
        id: 1,
        plan: "1 week",
        meals: ["breakfast", "lunch"],
        mealPreferance: "Non-vegeterian",
        status: "active",
        autoRenew: "1",
        unreturnedBoxes: "2",
        childDetails: {
          firstName: "Jhon",
          lastName: "Doe",
          age: "10",
          gender: "boy",
        },
      },
      {
        id: 2,
        plan: "2 weeks",
        meals: ["breakfast"],
        mealPreferance: "Vegeterian",
        status: "paused",
        autoRenew: "0",
        unreturnedBoxes: "",
        childDetails: {
          firstName: "Sarah",
          lastName: "Rose",
          age: "8",
          gender: "girl",
        },
      },
    ],
    orders: [
      {
        id: "ORD98765",
        products: [
          {
            title: "Lunch Box",
            price: 100,
            image: require("../../assets/images/order1.png"),
          },
        ],
        totalAmount: 500,
        orderDate: "09/Sep/2025",
        deliveryStatus: "pending",
      },
      {
        id: "ORD98766",
        products: [
          {
            title: "Water Bottle",
            price: 50,
            image: require("../../assets/images/order2.png"),
          },
          {
            title: "Mug",
            price: 30,
            image: require("../../assets/images/order2.png"),
          },
          {
            title: "Lunch Box",
            price: 100,
            image: require("../../assets/images/order2.png"),
          },
          {
            title: "School Bag",
            price: 200,
            image: require("../../assets/images/order2.png"),
          },
        ],
        totalAmount: 500,
        orderDate: "09/Sep/2025",
        deliveryStatus: "delivered",
      },
    ],
    user: {
      firstName: "Abhirami",
      lastName: "Susith",
      photo:
        "https://plus.unsplash.com/premium_photo-1688350808212-4e6908a03925?q=80&w=1169&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    notifications: [
      {
        title: "Subscription Successful",
        createdAt: "",
      },
    ],
  };
  const initialCustomization = {
    id: 1,
    plan: "1 weeks",
    daysInPlan: "5",
    meals: ["breakfast", "lunch"],
    mealPreferance: "Non-vegetarian",
    status: "active",
    childDetails: {
      firstName: "Sarah",
      lastName: "Rose",
      age: "8",
      gender: "girl",
    },
    weeks: [
      { week: 1, dates: "6-10 Oct, 2025" },
      { week: 2, dates: "13-17 Oct, 2025" },
    ],
    customizationPending: "1",
  };
  const page = {
    promoCode: [
      { title: "50% OFF with code", code: "SchoolsBack" },
      { title: "20% OFF with code", code: "FirstOrder" },
    ],
  };

  return (
    <>
      {/* <FullScreenLoading /> */}
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={page.promoCode} />

        <BodyWrapper className="lg:mb-0">
          <UpgradeMealSelection meal={initialCustomization} />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default UpgradeMealSubsctiptionPage;
